export default __webpack_public_path__ + "static/media/tiktok.5b46a857.svg";